/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2024.

!Changelog

2024
	08-02-2024
	- [BORN] This class is born. Hooray!

!Usage

	function.onready();
	
!Wishlist

	none
	
*/
  
var specific_colormode = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {

		var _mode 		= $('.page').data('mode');

		/*
		Remove
		*/
		$('.js-header').removeClass('light-mode dark-mode');
		$('.js-hero').removeClass('light-mode dark-mode');

		/*
		Add
		*/
		$('.js-header').addClass(_mode + '-mode');
		$('.js-hero').addClass(_mode + '-mode');
	
	};

	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	// none
		
}).apply(specific_colormode); 
